import { registerComponent } from '../app'
import { OPEN_AFTERPAY, CLOSE_AFTERPAY } from '../events'

const AfterpayOverlay = (scope, el) => {
    const props = {
        loadedClass: "overlay__hidden",
        openClass: "overlay__visible"
    };
    scope.on(OPEN_AFTERPAY, () => {
        el.classList.add(props.openClass)
    })

    scope.on(CLOSE_AFTERPAY, () => {
        el.classList.remove(props.openClass)
    })

}

registerComponent('afterpay-overlay', AfterpayOverlay)

// console.log('after-pay is working');

//         const props = {
//             loadedClass: "overlay__hidden",
//             activeClass: "overlay__visible"
//         };


//         this.openButton = el.querySelector(".affterpay__button");
//         this.closeButton = el.querySelector(".afterpay__close");
//         this.overlay = el.querySelector(".afterpay__overlay");


//     const openAfterPay = () => {

//         this.openButton.addEventListener('click', e => {

//             this.formClass.classList.remove(this.props.loadedClass);
//             this.formClass.classList.add(this.props.activeClass);
//             $("body").addClass("body--unscrollable");

//         });

//     }

//     const closeAfterPay = () => {

//         this.closeButton.addEventListener('click', e => {

//             this.formClass.classList.remove(this.props.activeClass);
//             this.formClass.classList.add(this.props.loadedClass);
//             $("body").removeClass("body--unscrollable");

//         });

//     }